import { Box, Collapse, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { voucherCodeFormName } from '../../../constants/checkout.constant';
import LocaleKeys from '../../../locales/keys';
import VoucherCodeForm from '../formControls/voucherCodeControl';
import TransitionPaymentHeader from '../transitionPaymentHeader';

const useStyles = makeStyles((theme) => ({
  root: {
    '&.MuiCollapse-hidden': {
      display: 'none',
    },
    '&.MuiPaper-root': {
      background: 'unset',
    },
  },
  boxInnerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  paperContainer: {
    border: 'none',
    padding: '10px 15px',
    backgroundColor: 'unset',
  },
  heading: {
    fontSize: '25px',
    fontFamily: 'Formula1-Regular',
    fontWeight: 500,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
  },
  container: {
    backgroundColor: 'unset',
  },
}));

const VoucherCode = ({
  language,
  handleVoucherSaveClick,
  credentialErrorMessage,
  handleVoucherCancelClick,
}) => {
  const animationInMilliSeconds = 350;
  const timeout = {
    appear: animationInMilliSeconds,
    enter: animationInMilliSeconds,
    exit: animationInMilliSeconds,
  };
  const { t } = useTranslation();
  const classes = useStyles();
  const setFocusRef = useRef(null);
  const [toggleBox, setToggleBox] = useState({
    voucherCode: false,
  });

  const setToggleBoxContainer = (eventType, isActive) => {
    const getCheckedValue = { ...toggleBox, [eventType]: isActive };
    setToggleBox(getCheckedValue);
  };

  const handleClick = (eventType) => {
    setToggleBoxContainer(eventType, true);
  };
  const handleSaveClick = (eventType) => {
    handleVoucherSaveClick(eventType);
  };
  const handleCancelClick = (eventType) => {
    const { name, formik } = eventType;
    formik?.resetForm();
    setToggleBoxContainer(name, false);
    handleVoucherCancelClick();
  };

  return (
    <Box className="panel-default">
      <Paper
        elevation={4}
        variant="outlined"
        className={classes.paperContainer}
        square
      >
        <TransitionPaymentHeader
          headingLabel={t(
            LocaleKeys.payment.orders.subscriptionItemApplyCouponHeaderLabel,
          )}
          classes={classes}
          fadeIn={toggleBox.voucherCode}
          name={voucherCodeFormName}
          clickHandler={handleClick}
        />
        <div className={classes.container}>
          <Collapse
            data-testid={`collapse-enter`}
            in={toggleBox.voucherCode}
            timeout={timeout}
            onEntered={() => {
              setFocusRef?.current && setFocusRef?.current.focus();
            }}
          >
            <Paper elevation={0} className={classes.root}>
              <div />
              <div>
                <VoucherCodeForm
                  handleCancel={handleCancelClick}
                  handleSave={handleSaveClick}
                  language={language}
                  formData={{ voucherCode: '' }}
                  formName={voucherCodeFormName}
                  autoFocusRef={setFocusRef}
                  credentialErrorMessage={credentialErrorMessage}
                />
              </div>
            </Paper>
          </Collapse>
        </div>
      </Paper>
    </Box>
  );
};

export default VoucherCode;
